// extracted by mini-css-extract-plugin
module.exports = {"myDIV":"select_myDIV__qlVlz","hide":"select_hide__1DxEO","underline_special":"select_underline_special__6Z8iu"};